import { UIText2 } from '@cian/ui-kit';
import { numberToPrettyString } from '@cian/utils';

import { clsx } from 'clsx';
import { type FC } from 'react';

import { Link } from '@/packages/shared-ui';

import styles from './QuickLinkItem.css';

export type QuickLinkItemProps = {
  url: string;
  offersCount: number;
  title: string;
  paddingLink?: 4 | 8;
  track(): void;
  short?: boolean;
};

export const QuickLinkItem: FC<QuickLinkItemProps> = props => {
  const { url, title, offersCount, paddingLink, track, short } = props;

  return (
    <Link data-testid="quick-link-item" display="inline" href={url} target="_self" track={track}>
      <div
        className={clsx(
          styles['link'],
          !!paddingLink && styles[`padding-link-${paddingLink}`],
          short && styles['link-short'],
        )}
      >
        <span className={styles['link-title']}>
          <UIText2 color="accent-main-primary">{title}</UIText2>
        </span>
        <span className={styles['link-dots']} />
        <span className={styles['link-count']}>
          <UIText2 color="gray60_100">{numberToPrettyString(offersCount)}</UIText2>
        </span>
      </div>
    </Link>
  );
};
